import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-invoice-load-stop",
  "use": "icon-invoice-load-stop-usage",
  "viewBox": "0 0 8 8",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 8 8\" id=\"icon-invoice-load-stop\"><circle cx=\"4\" cy=\"4\" r=\"3.5\" fill=\"#fff\" stroke=\"#7F8596\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol